<template>
  <div class="container buttons-mobile">
    <div class="mobile-footer-wrapper footer-fixed">
      <div class="mobile-footer-content">
        <div class="mobile-footer-choosen">
          <button @click="goToFavorite" class="">
            <img src="../../assets/icons/Love.svg" alt="" />
            <div>
              <span class="selected-counter">{{ favoriteFlats.length }}</span>
            </div>
          </button>
          <span class="selected-text">Обрані</span>
        </div>

        <div class="mobile-footer-ads">
          <button class="add-new-object" type="button">
            <router-link tag="button" to="/add-advertisement">
              <img src="../../assets/icons/AddApartment.svg" alt="" />
            </router-link>
          </button>
          <span class="selected-text">Оголошення</span>
        </div>

        <div class="mobile-footer-filter">
          <button
            :class="{ active: isFlatFilterUsed }"
            class="filter-buttons"
            @click="filterBtnHandler"
          >
            <img src="../../assets/icons/Filter.svg" alt="" />
          </button>
          <span class="selected-text">Фільтр</span>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showFilterRemoveList"
      width="100%"
      top="35vh"
      center
    >
      <div
        v-show="showFilterRemoveList"
        class="filter-controls footer-controls-filter"
      >
        <div class="style-mobile-filter-footer">Мій Фільтр</div>
        <div class="filter-remove-list" v-if="flatParams">
          <!--ROOMS              -->
          <button
            v-for="(item, index) in Object.entries(flatFilter.rooms)"
            v-if="item[1]"
            :key="item[0] + index"
            @click="
              filterHandler({
                rooms: { ...flatFilter.rooms, [item[0]]: false },
              })
            "
            class="transparent-btn"
            type="button"
          >
            {{ flatParams.rooms[item[0]] }} к <span>&times;</span>
          </button>

          <!-- TYPE REALTY              -->
          <button
            v-for="(item, index) in flatFilter.type_realty"
            :key="item + 'type_realty'"
            @click="
              filterHandler({
                type_realty: flatFilter.type_realty.filter((el) => el !== item),
              })
            "
            class="transparent-btn"
            type="button"
          >
            {{ flatParams.type_realties.find((el) => el.id === item).name }}
            <span>&times;</span>
          </button>

          <!--DISTRICTS              -->
          <button
            v-for="(item, index) in flatFilter.districts"
            :key="item + 'district'"
            class="transparent-btn"
            type="button"
            @click="
              filterHandler({
                districts: flatFilter.districts.filter((el) => el !== item),
              })
            "
          >
            {{
              flatParams.districts.find((district) => item === district.id).name
            }}
            <span>&times;</span>
          </button>

          <!--PRICE              -->
          <button
            class="transparent-btn"
            type="button"
            v-if="
              flatFilter.price.start !== defaultFlatsFilter.price.start ||
              flatFilter.price.end !== defaultFlatsFilter.price.end
            "
            @click="
              filterHandler({
                price: {
                  start: defaultFlatsFilter.price.start,
                  end: defaultFlatsFilter.price.end,
                },
              })
            "
          >
            {{ flatFilter.price.start }} - {{ flatFilter.price.end }}
            {{ currency === 'usd' ? '$' : '₴' }}

            <span>&times;</span>
          </button>

          <!-- FLOOR              -->
          <button
            v-for="(item, index) in Object.entries(flatFilter.floor)"
            v-if="item[1]"
            :key="item[0] + 'floor'"
            @click="
              filterHandler({
                floor: { ...flatFilter.floor, [item[0]]: false },
              })
            "
            class="transparent-btn"
            type="button"
          >
            {{ flatParams.floor[item[0]] }} <span>&times;</span>
          </button>

          <!--STATES              -->
          <button
            v-for="(item, index) in flatFilter.states"
            :key="item + 'state'"
            @click="
              filterHandler({
                states: flatFilter.states.filter((el) => el !== item),
              })
            "
            class="transparent-btn"
            type="button"
          >
            {{ flatParams.states.find((elem) => item === elem.id).name }}
            <span>&times;</span>
          </button>

          <!--PLANNINGS              -->
          <button
            v-for="(item, index) in flatFilter.plannings"
            :key="item + 'planning'"
            @click="
              filterHandler({
                plannings: flatFilter.plannings.filter((item) => !item),
              })
            "
            class="transparent-btn"
            type="button"
          >
            {{ flatParams.plannings.find((elem) => item === elem.id).name }}
            <span>&times;</span>
          </button>

          <!-- Material              -->
          <button
            v-for="(item, index) in Object.entries(flatFilter.material)"
            v-if="item[1]"
            :key="item[0] + 'material'"
            @click="
              filterHandler({
                material: { ...flatFilter.material, [item[0]]: false },
              })
            "
            class="transparent-btn"
            type="button"
          >
            {{ flatParams.material[item[0]] }} <span>&times;</span>
          </button>

          <!--AREA              -->
          <button
            class="transparent-btn"
            type="button"
            v-if="
              flatFilter.area.start !== flatParams.area.start ||
              flatFilter.area.end !== flatParams.area.end
            "
            @click="
              filterHandler({
                area: {
                  start: flatParams.area.start,
                  end: flatParams.area.end,
                },
              })
            "
          >
            {{ flatFilter.area.start }} - {{ flatFilter.area.end }}м<sup>2</sup>
            <span>&times;</span>
          </button>
        </div>
        <div class="btn-background">
          <div class="action-buttons">
            <el-button
              class="buttons-filter-mobile rounded-btn blue active"
              type="primary"
              @click="
                showFilterRemoveList = false
                resetFlatFilter()
              "
              >Очистити</el-button
            >
            <el-button
              type="primary"
              @click="$store.commit('setShowFilter', true)"
              class="buttons-filter-mobile"
            >
              <div>змінити фільтр</div>
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import FiltersMobile from '@/components/home/FiltersMobile'
import IconBase from '@/components/icons/IconBase'
import Heartfooter from '@/components/icons/Heartfooter'
import Plus from '@/components/icons/Plus'
import FilterIcon from '@/components/icons/FilterIcon'
import { SORTING_LIST } from '@/helper/emptyFilters'
import { mapGetters } from 'vuex'

export default {
  name: 'Footer_button',
  components: {
    FilterIcon,
    FiltersMobile,
    Plus,
    Heartfooter,
    IconBase,
  },
  mounted() {
    const sortBlock = document.querySelector('.sorting-part')
    sortBlock.offsetTop < window.scrollY
      ? (this.visible = true)
      : (this.visible = false)
    window.addEventListener('scroll', (event) => {
      sortBlock.offsetTop < window.scrollY
        ? (this.visible = true)
        : (this.visible = false)
    })
  },
  computed: {
    ...mapGetters({
      flatParams: 'getFlatsFilterParams',
      flatFilter: 'getFlatsFilter',
      defaultFlatsFilter: 'getDefaultFlatsFilter',
      isFlatFilterUsed: 'isFlatFilterUsed',
      sort: 'getFlatsSorting',
      pagination: 'getFlatsPagination',
      currency: 'getGlobalCurrency',
      usdCourse: 'getUsdCourse',
      favoriteFlats: 'getFavoriteFlatList',
      showFilter: 'getShowFilter',
    }),
  },
  watch: {
    isFlatFilterUsed(newValue) {
      if (!newValue) this.showFilterRemoveList = false
    },
    showFilter(curr, prev) {
      if (!curr && prev) {
        this.showFilterRemoveList = false
      }
    },
  },
  data() {
    return {
      centerDialogVisible: false,
      visible: false,
      showFilterRemoveList: false,
      value: 1,
      sorting: SORTING_LIST,
    }
  },
  methods: {
    sortHandler(event) {
      this.$store.dispatch('changeFlatsSorting', event)
    },
    goToFavorite() {
      this.$router.push({ name: 'favorite' })
    },
    resetFlatFilter() {
      //reset all filter filter. null parameter is required
      this.$store.dispatch('changeFlatsFilter', null)
    },
    filterBtnHandler() {
      if (this.$route.name.toLowerCase() !== 'home') {
        this.$router.push({ path: '/' })
        return
      }
      if (!this.isFlatFilterUsed) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      }
      this.showFilterRemoveList = !this.showFilterRemoveList
    },
    filterHandler(value) {
      this.$store.dispatch('changeFlatsFilter', {
        ...this.flatFilter,
        ...value,
      })
    },
  },
}
</script>
